import React from 'react';
import PropTypes, { checkPropTypes } from 'prop-types';
import { IconButton, Icon } from '@sumtotal/react-foundation';
import styled from 'styled-components';
import useUserContext from '../../hooks/useUserContext';

const MyGuideIconButton = styled(IconButton)`
  padding: 0.425rem 0.3rem;
  color: ${(props) => props.theme.variables.headerBarColor};
  &.Mui-disabled {
    color: ${(props) => props.theme.variables.headerBarColor};
    opacity: 0.5;
  }
  &:focus {
    background-color: ${(props) => props.theme.variables.leftNavHeaderBackground};
    outline: -webkit-focus-ring-color auto 0.0625rem;
  }
`;

const MyGuide = (props) => {
  const { myGuideMenu = defaultProps.myGuideMenu } = props;
  checkPropTypes(MyGuide.propTypes, props, 'prop', MyGuide.name);
  const onMyGuideClick = () => {
    window.GmCXt.openAppPanel();
  };
  const { user } = useUserContext();
  const disableMyGuide = user.isEmulatedUser ? false : user.mustAnswerSecurityQuestions;
  return (
    <MyGuideIconButton
      size="small"
      color="inherit"
      label={myGuideMenu.name}
      onClick={() => onMyGuideClick()}
      disabled={disableMyGuide}
    >
      <Icon iconType="IcomoonIcon" iconName="My Guide" size={1.75} />
    </MyGuideIconButton>
  );
};

// PropType check
MyGuide.propTypes = {
  /**
   * MyGuide SitemapNode
   */
  myGuideMenu: PropTypes.oneOfType([PropTypes.object])
};

const defaultProps = {
  myGuideMenu: {}
};

export default MyGuide;
